"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var _HTMLRenderer = _interopRequireDefault(require("../../common/components/HTMLRenderer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TpmIntroCardImage
 * @author xlongjiang
 * @created 2025-11-03 03:27:45
 */

/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTpmIntroCardImageData = (properties, options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? '' : _ref$tag,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$bgColor = _ref.bgColor,
    bgColor = _ref$bgColor === void 0 ? '' : _ref$bgColor,
    _ref$bgImg = _ref.bgImg,
    bgImg = _ref$bgImg === void 0 ? '' : _ref$bgImg,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? 3 : _ref$columns,
    _ref$isCarousel = _ref.isCarousel,
    isCarousel = _ref$isCarousel === void 0 ? false : _ref$isCarousel,
    _ref$openText = _ref.openText,
    openText = _ref$openText === void 0 ? '' : _ref$openText,
    _ref$packText = _ref.packText,
    packText = _ref$packText === void 0 ? '' : _ref$packText,
    _ref$logoTitle = _ref.logoTitle,
    logoTitle = _ref$logoTitle === void 0 ? '' : _ref$logoTitle,
    _ref$logoLine = _ref.logoLine,
    logoLine = _ref$logoLine === void 0 ? '1' : _ref$logoLine,
    _ref$logoList = _ref.logoList,
    logoList = _ref$logoList === void 0 ? [] : _ref$logoList;
  const handleItems = items.map((item, index) => {
    const _ref2 = item || {},
      img = _ref2.img,
      video = _ref2.video,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? '' : _ref2$title,
      _ref2$desc = _ref2.desc,
      desc = _ref2$desc === void 0 ? '' : _ref2$desc,
      linkText = _ref2.linkText,
      linkHref = _ref2.linkHref;
    const linkExtendProps = {
      'report-event': 'click_IntroCardImage_link',
      'report-ext1': index,
      'report-ext2': linkText || '',
      'report-ext3': linkHref || '',
      target: '_blank'
    };
    return {
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url,
      video: video ? (0, _componentUtils.doComponentsUploadEvent)(video || '').url : null,
      title,
      desc,
      link: linkText && linkHref ? /*#__PURE__*/React.createElement(_tpmProductIntl.Link, Object.assign({
        href: linkHref
      }, linkExtendProps, {
        icon: true
      }), linkText) : null
    };
  });
  const handledLogoList = logoList === null || logoList === void 0 ? void 0 : logoList.map((activityItem, index) => {
    const _ref3 = activityItem || {},
      img = _ref3.img,
      _ref3$href = _ref3.href,
      href = _ref3$href === void 0 ? '' : _ref3$href,
      _ref3$tooltip = _ref3.tooltip,
      tooltip = _ref3$tooltip === void 0 ? '' : _ref3$tooltip;
    const btnExtendProps = {
      'report-event': 'click_IntroCardImage_logo_item',
      'report-ext1': index,
      'report-ext2': href || '',
      target: '_blank'
    };
    return {
      tooltip,
      btnExtendProps,
      href,
      img: (0, _componentUtils.doComponentsUploadEvent)(img || '').url
    };
  });
  return {
    porintId,
    tag,
    title: title ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: title
    }) : '',
    desc: desc ? /*#__PURE__*/React.createElement(_HTMLRenderer.default, {
      html: desc
    }) : '',
    bg,
    bgColor,
    bgImg: (0, _componentUtils.doComponentsUploadEvent)(bgImg || '').url,
    items: handleItems,
    columns,
    isCarousel,
    openText,
    packText,
    logoList: handledLogoList,
    logoLine,
    logoTitle
  };
};
function splitIntoGroups(arr, groups) {
  if (groups <= 0) return [];
  const len = arr.length;
  if (groups > len) {
    // 处理类型安全的分组
    const filled = arr.map(item => [item]);
    const empty = Array(groups - len).fill([]);
    return [...filled, ...empty];
  }
  const baseSize = Math.floor(len / groups);
  const remainder = len % groups;
  const result = [];
  let start = 0;
  for (let i = 0; i < groups; i++) {
    const chunkSize = baseSize + (i < remainder ? 1 : 0);
    result.push(arr.slice(start, start + chunkSize));
    start += chunkSize;
  }
  return result;
}
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} "数据"表单内容
  style,
  // {object} "样式"表单内容
  commonStyle,
  // {object} "组件自定义样式"表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatTpmIntroCardIm = formatTpmIntroCardImageData(data, {
        domains
      }),
      tag = _formatTpmIntroCardIm.tag,
      porintId = _formatTpmIntroCardIm.porintId,
      title = _formatTpmIntroCardIm.title,
      desc = _formatTpmIntroCardIm.desc,
      bg = _formatTpmIntroCardIm.bg,
      bgColor = _formatTpmIntroCardIm.bgColor,
      bgImg = _formatTpmIntroCardIm.bgImg,
      columns = _formatTpmIntroCardIm.columns,
      isCarousel = _formatTpmIntroCardIm.isCarousel,
      items = _formatTpmIntroCardIm.items,
      openText = _formatTpmIntroCardIm.openText,
      packText = _formatTpmIntroCardIm.packText,
      logoLine = _formatTpmIntroCardIm.logoLine,
      logoList = _formatTpmIntroCardIm.logoList,
      logoTitle = _formatTpmIntroCardIm.logoTitle;
    const mun = Number(logoLine);
    const logoListResult = splitIntoGroups(logoList, mun);
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TpmIntroCardImage`
    }, (0, _reportUtil.reportShow)(['show_newUI_TpmIntroCardImage', componentKey, title || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      tag: tag,
      title: title,
      desc: desc,
      bg: bg,
      bgColor: bgColor,
      bgImg: bgImg,
      type: 'full'
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Module, null, /*#__PURE__*/React.createElement(_tpmProductIntl.IntroCard2, {
      columns: columns,
      isCarousel: isCarousel,
      items: items,
      openText: openText,
      packText: packText
    })), !!logoList.length && /*#__PURE__*/React.createElement(_tpmProductIntl.Panel, {
      title: logoTitle
    }, logoListResult.map((item, index) => /*#__PURE__*/React.createElement(_tpmProductIntl.CaseLogo, {
      logos: item || []
    })))));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}